
import React from "react";
import {
  Button,
  FormControl,
  FormControlLabel,
  FormLabel,
  IconButton,
  Modal,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers";

const UpdateWorkbenchStatus = ({ isModalOpen, handleModalClose, handleSubmit, updateParameters, setUpdateParameters })=> {

  return (
    <Modal
      open={isModalOpen}
      onClose={handleModalClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <div className="customize-modal">
        <div className="modal-head">
          <h2>Update Status</h2>
          <IconButton
            className="close-modal-btn p-0"
            onClick={handleModalClose}
          >
            <HighlightOffIcon />
          </IconButton>
        </div>
        <div className="modal-body-content">
          <FormControl className="mb-4">
            <FormLabel id="update_status" className="radio-label">
              Please select an option to update the status of Application Filing
            </FormLabel>
            <RadioGroup
              row
              aria-labelledby="update_status"
              name="update_status"
              value={updateParameters?.status || ""}
              onChange={(e) => {
                setUpdateParameters((prevState)=> ({...prevState,status:e.target.value}));
              }}
            >
              {/* <FormControlLabel
                value="Ack. Awaited"
                control={<Radio />}
                label="Ack. Awaited"
              /> */}
              <FormControlLabel
                value="Filed"
                control={<Radio />}
                label="Filed"
              />
            </RadioGroup>
          </FormControl>

          <div className="row">
            <div className="col-12">
              <TextField
                id="remarks"
                label="Remarks"
                variant="outlined"
                className="w-100 mb-3"
                value={updateParameters?.remarks || ""}
                onChange={(e) => {
                    setUpdateParameters((prevState) => ({...prevState,remarks:e.target.value}))
                }}
              />
            </div>
            <div className="col-md-6">
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DesktopDatePicker
                  className="w-100 mb-3"
                  label="Date of Filing:"
                  inputFormat="MM/dd/yyyy"
                  value={updateParameters?.filing_date}
                  maxDate={new Date()}
                  onChange={(event) => {
                    setUpdateParameters((prevState) => ({...prevState,filing_date:event}))
                  }}
                  renderInput={(params) => <TextField {...params} />}
                />
              </LocalizationProvider>
            </div>
            <div className="col-md-6">
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <TimePicker
                  className="w-100 mb-3"
                  label="Time of Filing:"
                  value={updateParameters?.filing_date}
                  onChange={(event) => {
                    setUpdateParameters((prevState) => ({...prevState,filing_date:event}))
                  }}
                  renderInput={(params) => <TextField {...params} />}
                />
              </LocalizationProvider>
            </div>
          </div>
        </div>
        <div className="modal-foot">
          <Button
            type="button"
            disabled = {!(updateParameters?.status && updateParameters?.filing_date)}
            className="btn-theme px-5"
            onClick={(e) => {
                handleSubmit(updateParameters);
              handleModalClose();
            }}
          >
            Update
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default UpdateWorkbenchStatus;
